
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: ""
    },
    categoryLink: {
      type: String,
      default: "#"
    },
    categoryImage: {
      type: String,
    },
    categoryName: {
      type: String,
      default: 'Category Name'
    }
  },
  data(){
    return{
      promotedCities: null,
    }
  },
  mounted() {
    this.getPromotedCities()
  },
  methods:{
   async getPromotedCities(){
      this.promotedCities = await fetch(this.$config.fetchUrl + '/api/cities/app/getPromotedCities').then(res => res
        .text());
      this.promotedCities = this.getCryptKey(this.promotedCities);
    },
    //To display image of activities
    activitiesImage(image) {
      if (image && image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },
  }
}

